export default __webpack_public_path__ + "0f0bc017e2b0b08edfa0706b7c80b43e.png";